import { useState } from 'react';

import Box from '@mui/material/Box';
import IconButton from "@mui/material/IconButton";
import SettingsIcon from '@mui/icons-material/Settings';

import CalendarModal from "@plannel/components/modal/CalendarModal"

const CycleCalendarRenderer = props => {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
  const { setSnackInfo, editable } = props;

  const [calendarModalOpen, setCalendarModalOpen] = useState(false);
  const [editedCell, setEditedCell] = useState({});

  const isDisable = () => {
    if (editable) {
      if (typeof editable === "function") {
        return !editable(props);
      } else {
        return editable;
      }
    }

    return false;
  }
  
  const buttonClicked = () => {
    if (!isDisable()) {
      setEditedCell(props);
      setCalendarModalOpen(true);
    }
  }

  return (
    <>
      <Box sx={{ display: "flex" }} onDoubleClick={buttonClicked}>
        <Box component={"span"}>{cellValue}</Box>
        <Box component={"span"} sx={{ ml: "auto" }}>
          <IconButton aria-label="settings" size="small" sx={{ verticalAlign: "baseline" }} disabled={isDisable()} onClick={buttonClicked}>
            <SettingsIcon size="small" sx={{ width: "15px", height: "15px" }} />
          </IconButton>
        </Box>
      </Box>
      <CalendarModal
        showDetail
        modalOpen={calendarModalOpen}
        setModalOpen={setCalendarModalOpen}
        editedCell={editedCell}
        setSnackInfo={setSnackInfo}
      />
    </>
  );
}

export default CycleCalendarRenderer;
